const topbar = {
    docs: 'Belgeler',
    help: 'Yardım',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
